import { useState } from 'react'

import Icon from '@mdi/react'
import { mdiChevronUp } from '@mdi/js'
import { Dropdown, Menu } from 'antd'
import { PageSizes } from '../../utils/Enums'
import { usePagination, LeftDOTS, RightDOTS } from '../../hooks/usePagination'
import { LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined, EllipsisOutlined } from '@ant-design/icons'

const Pagination = (props) => {
	const { setPageInfo, setBackendPageInfo, totalCount, pageInfo } = props
	const [mouseEnter, setMouseEnter] = useState(null)
	const DropdownMenu = (
		<Menu
			onClick={(event) => {
				setPageInfo({ pageNo: 1, pageSize: parseInt(event?.key) })
			}}
		>
			{Object.keys(PageSizes).map((size) => {
				return (
					<Menu.Item
						key={size}
						className={`hover:bg-primary-50 hover:text-primary-800 ${pageInfo.pageSize === parseInt(size) && 'font-semibold text-primary-800'}`}
					>
						{size} / Page
					</Menu.Item>
				)
			})}
		</Menu>
	)

	const paginationRange = usePagination({ currentPage: pageInfo?.pageNo, totalCount, siblingCount: 1, pageSize: pageInfo?.pageSize })

	let lastPage = paginationRange[paginationRange?.length - 1]
	const firstPageIndex = 1
	return (
		<div className='flex cursor-pointer flex-wrap items-center justify-center h-[40px]'>
			<div
				className={`flex items-center mx-[2px] h-[40px] rounded-sm border-[1px] px-[8px] ${pageInfo.pageNo === firstPageIndex && `cursor-not-allowed`}`}
				onClick={() => {
					pageInfo?.pageNo > firstPageIndex && setPageInfo((prev) => ({ ...prev, pageNo: prev?.pageNo - 1 }))
				}}
			>
				<LeftOutlined />
			</div>
			{paginationRange.map((pageNumber, index) => {
				// prettier-ignore
				if ([LeftDOTS].includes(pageNumber)) {
					return (
						<div
							key={index}
							className='flex items-center rounded-sm mx-2 h-[40px]'
							onMouseEnter={() => setMouseEnter(LeftDOTS)}
							onMouseLeave={() => setMouseEnter(null)}
							onClick={() => {
								setPageInfo((prev) => ({ ...prev, pageNo: pageInfo.pageNo - 5 < firstPageIndex ? firstPageIndex : pageInfo.pageNo - 5 }))
							}}
						>
							{mouseEnter === LeftDOTS ? <DoubleLeftOutlined className='!text-primary-800'  /> : <EllipsisOutlined className='text-lg !text-[#717171de]' />}
						</div>
					)
				}
				if ([RightDOTS].includes(pageNumber)) {
					return (
						<div
							key={index}
							className='flex items-center rounded-sm mx-2 h-[40px]'
							onMouseEnter={() => setMouseEnter(RightDOTS)}
							onMouseLeave={() => setMouseEnter(null)}
							onClick={() => {
								setPageInfo((prev) => ({ ...prev, pageNo: pageInfo.pageNo + 5 > lastPage ? lastPage : pageInfo.pageNo + 5 }))
							}}
						>
							{mouseEnter === RightDOTS ? <DoubleRightOutlined className='!text-primary-800' /> : <EllipsisOutlined className='text-lg !text-[#717171de]' />}
						</div>
					)
				}
				return (
					<div
						key={index}
						className={`flex items-center mx-1 rounded-sm border-[1px] px-3 h-[40px] ${
							pageInfo.pageNo === pageNumber && `border-[1.5px] border-primary-800 font-[600] text-primary-800`
						}`}
						onClick={() => setPageInfo((prev) => ({ ...prev, pageNo: pageNumber }))}
					>
						{pageNumber}
					</div>
				)
			})}
			<div
				className='flex items-center mx-[2px] h-[40px] rounded-sm border-[1px] px-[8px]'
				onClick={() => {
					// prettier-ignore
					(pageInfo?.pageNo === lastPage || !lastPage) && setBackendPageInfo((prev) => ({ ...prev, pageNo: prev.pageNo + 1 }));

					pageInfo?.pageNo === lastPage
						? setPageInfo((prev) => ({ ...prev, pageNo: lastPage }))
						: !lastPage
						? setPageInfo((prev) => ({ ...prev, pageNo: 1 }))
						: setPageInfo((prev) => ({ ...prev, pageNo: prev?.pageNo + 1 }))
				}}
			>
				<RightOutlined />
			</div>
			<Dropdown
				setPageInfo={setPageInfo}
				overlay={DropdownMenu}
				trigger={['click']}
				className='flex items-center mx-2 h-[40px] rounded-sm border-[1px] px-[8px] py-[6.5px]'
			>
				<div className='flex flex-row p-4'>
					<p className='px-2 font-bold self-center'>{pageInfo?.pageSize.toString() + ' / Page'}</p>
					<Icon path={mdiChevronUp} size={1} />
				</div>
			</Dropdown>
		</div>
	)
}

export default Pagination
